export class SoundUtils {
    private static audioContext: AudioContext | null = null;

    private static getContext(): AudioContext {
        if (!this.audioContext) {
            this.audioContext = new ((window as any).AudioContext || (window as any).webkitAudioContext)();
        }
        return this.audioContext;
    }

    public static beep(): void {
        try {
            const context = this.getContext();
            const oscillator = context.createOscillator();
            const gainNode = context.createGain();

            oscillator.connect(gainNode);
            gainNode.connect(context.destination);

            gainNode.gain.setValueAtTime(0.1, context.currentTime); // Volume
            oscillator.frequency.setValueAtTime(440, context.currentTime); // Frequency in Hz (A4 note)
            oscillator.type = 'sine';

            oscillator.start(context.currentTime);
            oscillator.stop(context.currentTime + 0.1); // Beep for 0.1 seconds
        } catch (e) {
            console.error("SoundUtils.beep() failed:", e);
        }
    }
} 